
import Vue from 'vue'
export default Vue.extend({
  props: {
    label: String,
    icon: {
      type: String,
      default: 'mdi-help',
    },
    iconSize: {
      type: [String, Number],
      default: '64',
    },
    color: {
      type: String,
      default: 'primary',
    },
    dark: Boolean,
  },
})
